import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import config from "@/config";

const TransitionWrapper = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const token = localStorage.getItem(config.LOCAL_KEYS.SIGNUP_TOKEN);
  const user_identifier = localStorage.getItem("user_identifier");

  useEffect(() => {
    // Scroll to top on route change or refresh
    window.scrollTo(0, 0);

    // Redirect if no auth tokens
    if (!token && !user_identifier) {
      navigate("/sign-up");
      return;
    }
  }, [token, user_identifier, navigate, location?.pathname]); // Add location.pathname to reset on route change

  const variants = {
    initial: { opacity: 0, x: 100 },
    enter: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
    exit: {
      opacity: 0,
      x: -100,
      transition: { duration: 0.5, ease: "easeIn" },
    },
  };

  return (
    <motion.div
      key={location.pathname}
      initial="initial"
      animate="enter"
      exit="exit"
      variants={variants}
    >
      {children}
    </motion.div>
  );
};

export default TransitionWrapper;
